import React, { useEffect, useState } from "react";
import { Modal, Typography, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../Store/store";
import { resetUserData, setUserData ,isFirst2FASuggestion} from "../Store/Slice/userSlice";
import HTTPSCalls from "../Services/HTTPCalls";

const { Paragraph, Title } = Typography;

interface Enable2FASuggestionModalProps {
  openModel: boolean;
  setOpenModel: (value: boolean) => void;
}

const Enable2FASuggestionModal: React.FC<Enable2FASuggestionModalProps> = ({
  openModel,
  setOpenModel,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const First2FASuggestion = useSelector(isFirst2FASuggestion);

  useEffect(() => {
    if (First2FASuggestion) {
      setOpenModel(true);
      setHasOpened(true);
    }
  }, [First2FASuggestion]); 

  const handleEnable = () => {
    setOpenModel(false);
    navigate("/enable-2fa");
  };

  const handleDisable = async () => {
    try {
      setLoading(true);
      const res= await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.Disable2FA,{},{});
      if (res?.status) {
        message.success("Two-Factor Authentication disabled successfully!");
        dispatch(setUserData({ ...user, requiresTwoFactor: false}));

        setTimeout(() => setOpenModel(false), 200);
      } else {
        message.error("Failed to disable 2FA");
      }
    } catch (err) {
      console.error(err);
      message.error("Error disabling 2FA");
      dispatch(resetUserData());
      setOpenModel(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = async () => {
  try {
    setOpenModel(false);
    await HTTPSCalls.POST(HTTPSCalls.ENDPOINTS.Disablefirst2fasuggestion, {}, {});
    dispatch(setUserData({...user,isFirst2FASuggestion:false}));
  } catch (error) {
    console.error("Error disabling Disablefirst2fasuggestion:", error);
  }
};

  return (
    <Modal
      open={openModel}
      onCancel={handleCancel}
      footer={null}
      title={
        user?.requiresTwoFactor
          ? "Two-Factor Authentication"
          : "Enhance Your Account Security"
      }
      style={{paddingBottom:"5px"}}
    >
      <div style={{ textAlign: "center" }}>
        {user?.requiresTwoFactor ? (
          <>
            <Title level={4}>Turn Off Two-Factor Authentication?</Title>
            <Paragraph style={{ marginTop: 8 }}>
              Your account is currently protected by two-factor authentication.
              Are you sure you want to disable it? This will reduce your account security.
            </Paragraph>

            <div
              style={{
                marginTop: 24,
                display: "flex",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Button danger loading={loading} onClick={handleDisable}>
                Yes, Disable 2FA
              </Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </div>
          </>
        ) : (
          <>
            <Title level={4}>Enable Two-Factor Authentication</Title>
            <Paragraph style={{ marginTop: 8 }}>
              You don’t have two-factor authentication enabled yet.
              Enabling it adds an extra layer of protection to your account.
            </Paragraph>

            <div
              style={{
                marginTop: 24,
                display: "flex",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Button type="primary" onClick={handleEnable}>
                Enable Now
              </Button>
              <Button onClick={handleCancel}>Skip for Now</Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default Enable2FASuggestionModal;
